export default {
	/* 福利活动/任务弹窗 开始 */
	'exchange-coin': () => import('./welfare/ExchangeCoin.vue'),
	'day-sign': () => import('./welfare/DaySign.vue'),
	'push-off': () => import('./welfare/PushOff'),
	'push-on': () => import('./welfare/PushOn'),
	'calendar-keep': () => import('./welfare/calendarKeep'),
	'calendar-authority': () => import('./welfare/calendarAuthority'),
	// 福利任务每日签到现金奖励恭喜获得弹窗
	'sign-balance-congratulation': () => import('./welfare/SignBalanceCongratulation'),
	// 限时任务金 v1.0
	'limit-reward': () => import('./welfare/LimitRewardModal'),
	'limit-reward-2': () => import('./welfare/LimitRewardModal2'),
	'limit-reward-success': () => import('./welfare/LimitRewardSuccess'),
	'limit-reward-fail': () => import('./welfare/LimitRewardFail'),
	'first-retain': () => import('./welfare/FirstRetainModal'),
	'second-retain': () => import('./welfare/RetainModal2'),
	/* 福利活动/任务弹窗 结束 */

	/* 裂变弹窗 开始 */
	// 裂变 v1.0 弹窗
	'fission-rule': () => import('./fission/FissionRule.vue'),
	'fission-success': () => import('./fission/FissionSuccess'),
	'fission-quit': () => import('./fission/FissionQuit'),
	// 裂变 v1.3 弹窗
	'withdraw-rule': () => import('./fission/WithdrawRule'),
	'welfare-open': () => import('./fission/WelfareOpen'),
	'welfare-received': () => import('./fission/WelfareReceived'),
	'fission-day-sign': () => import('./fission/DaySign'),
	'activity-result': () => import('./fission/ActivityResult'),
	'bind-code-tip': () => import('./fission/BindCodeTip'),
	'day-sign-share-reward': () => import('./fission/DaySignShareReward'),
	'withdraw-bind-weChat': () => import('./fission/WithdrawBindWechat'),
	'withdraw-bind-phone': () => import('./fission/WithdrawBindPhone'),
	'withdraw-verified': () => import('./fission/WithdrawVerified'),
	'withdraw-verified-failed': () => import('./fission/WithdrawVerifiedFailed'),
	'withdraw-boss-tip': () => import('./fission/WithdrawBossTip'),
	// 首次邀请逻辑弹窗
	'first-invite-modal': () => import('@/components/common/modal/fission/FirstInviteModal/FirstInvitePriceModal.vue'),
	'first-invite-success-modal': () => import('@/components/common/modal/fission/FirstInviteModal/FirstInviteSuccessModal.vue'),

	'first-invite-ongoing-modal': () => import('@/components/common/modal/fission/FirstInviteModal2.0/FirstInviteOnGoingModal.vue'),
	'red-bag-need-open-modal': () => import('@/components/common/modal/fission/FirstInviteModal2.0/RedBagNeedOpenModal.vue'),
	'first-invite-success-modal2': () => import('@/components/common/modal/fission/FirstInviteModal2.0/FirstInviteSuccessModal2.0.vue'),

	'material-card-modal': () => import('@/components/material-reward/components/DrawModal/DrawModal.vue'),
	'material-entry-modal': () => import('@/components/material-reward/components/EntryModal/EntryModal.vue'),
	'material-retain-modal': () => import('@/components/material-reward/components/RetainModal/RetainModal.vue'),
	'material-order-modal': () => import('@/components/material-reward/components/OrderModal/OrderModal.vue'),
	// 绑定邀请码页面挽留弹窗
	'invite-code-retain-modal': () => import('@/components/common/modal/inviteCodeRetainModal'),
	'invite-code-auto-modal': () => import('@/components/common/modal/inviteCodeAutoModal'),
	/* 裂变弹窗 结束 */

	/* 活动弹窗 开始*/
	// 幸运大转盘
	'fortune-wheel': () => import('./activity/FortuneWheel.vue'),
	'fortune-reward': () => import('./activity/FortuneWheelReward'),
	// 注册流程
	'bind-weChat-withdraw': () => import('./register-process/BindWeChatWithdraw'),
	'bind-weChat-keep': () => import('./register-process/BindWechatKeep'),
	'withdraw-reward': () => import('./register-process/WithdrawReward'),
	// 限时任务奖励金 v2.0 弹窗
	limitActivity: () => import('./activity/LimitRewardAcitivity.vue'),
	LimitLottery: () => import('./activity/LimitRewardLottery.vue'),
	limitResult: () => import('./activity/LimitRewardResult.vue'),
	limitRemind: () => import('./activity/LimitRewardRemind.vue'),
	// 双人打卡活动
	doubleSignInEntry: () => import('./activity/double-sign-in/index.vue'),
	// 双人打卡活动-断签提示弹窗
	brokeSignTip: () => import('./activity/double-sign-in/BrokeSignTip.vue'),
	// 双人打卡活动-奖励红包
	signReward: () => import('./activity/double-sign-in/RewardEnvelope.vue'),
	// 双人打卡活动-领取红包
	getSignReward: () => import('./activity/double-sign-in/CashEnvelope.vue'),
	/* 活动弹窗 结束*/

	/* 提现板块弹窗 开始 */
	// 提现页退出拦截弹窗
	'withdraw-keep': () => import('./withdraw/withdrawKeep'),
	'gong-mao-dian-qian': () => import('./withdraw/GongMaoDianQian'),
	'withdraw-appointment': () => import('./withdraw/WeekendWithdrawAppointment'),
	'vip-payment': () => import('./withdraw/VIPPaymentModal'),
	/* 提现板块弹窗 结束 */

	/* 功能弹窗 开始 */
	// 图片预览
	imagePreview: () => import('./imagePreviewModal'),

	// 看资讯赚钱
	'news-rule-modal': () => import('@/components/news/components/RuleModal/RuleModal.vue'),
	'news-retain-modal': () => import('@/components/news/components/RetainModal/RetainModal.vue'),
	'news-retain-next-modal': () => import('@/components/news/components/RetainModal/RetainNextModal.vue'),
	'news-sign-modal': () => import('./welfare/DailySignModal'),

	// 金币汇率
	icons_rate_ongoing_modal: () => import('@/components/common/modal/welfare/IconsRateModal/OnGoingModal'),
	icons_rate_success_modal: () => import('@/components/common/modal/welfare/IconsRateModal/IconsRateSuccessModal'),
	icons_rate_confirm_modal: () => import('@/components/common/modal/welfare/IconsRateModal/ConfirmGiveUpModal'),
	icons_rate_share_success_modal: () => import('@/components/common/modal/welfare/IconsRateModal/ShareSuccessModal'),
	icons_rate_regret_modal: () => import('@/components/common/modal/welfare/IconsRateModal/RegretModal'),
	icons_rate_finally_success_modal: () => import('@/components/common/modal/welfare/IconsRateModal/FinallySuccessModal'),

	//  挂件管理
	pendant_rule_modal: () => import('@/components/common/modal/pendantManagement/rulesModal'),

	//  运营资源奖励弹窗
	operating_resources_modal: () => import('@/components/common/modal/welfare/OperatingResourcesModal'),

	//  特殊奖励
	special_price_modal: () => import('@/components/common/modal/welfare/SpecialPriceModal'),
	//   快音提现规则弹窗
	ky_withdraw_rule: () => import('@/components/common/modal/withdraw/withdrawRuleModal'),
	// ios 福利中心收益操作提示弹窗
	iosIncomeTip: () => import('./ios-welfare/incomeTip.vue'),
	// 会员续费套餐支付确认弹窗
	membershipPayConfirm: () => import('./membership-system/BuyConfirmModal.vue'),
	//  获得结果弹窗
	obtain_result_modal: () => import('@/components/common/modal/fission/ObtainResultModal'),

	// 体验金邀请成功弹窗
	success_invite_modal: () => import('@/components/common/modal/fission/ExperienceGold/SuccessInviteModal'),
	// 体验金恭喜获得
	gold_congratulations_modal: () => import('@/components/common/modal/fission/ExperienceGold/CongratulationsModal'),
	// 体验金兑换现金说明弹窗
	cash_exchange_instructions_modal: () => import('@/components/common/modal/fission/ExperienceGold/CashExchangeInstructionsModal'),
	exchange_history_modal: () => import('@/components/common/modal/fission/ExperienceGold/ExchangeHistoryModal'),
	// 体验金成功邀请好友弹窗
	invite_friend_success_modal: () => import('@/components/common/modal/fission/ExperienceGold/InviteFriendSuccess'),
	// 体验金邀请过程弹窗
	invite_process_modal: () => import('@/components/common/modal/fission/ExperienceGold/InviteProcessModal'),
	// 体验金成功提现弹窗
	success_withdraw_modal: () => import('@/components/common/modal/fission/ExperienceGold/SuccessWithdrawModal'),
	//  规则公共弹窗
	common_rule_modal: () => import('@/components/common/modal/commonRuleModal'),
	//  摇钱树规则
	cash_tree_rule_modal: () => import('@/components/common/modal/activity/cash-tree/CashTreeRuleModal'),
	// 摇钱树结果
	cash_tree_result_modal: () => import('@/components/common/modal/activity/cash-tree/CashTreeResultModal'),
	//  提现结果页裂变弹窗
	status_fission_modal: () => import('@/components/common/modal/withdraw/withdrawStatusFissionModal'),
	//  新人首次分享弹窗
	new_user_share_modal: () => import('@/components/common/modal/fission/NewUserShareModal'),
	// 精彩视频提现说明弹窗
	withdraw_video_desc_modal: () => import('@/components/common/modal/withdraw/VideoWithdrawDescModal'),
	//  裂变提现页提示弹窗
	fission_withdraw_prompt: () => import('@/components/common/modal/fission/WithdrawInvitePromptModal'),

	// 恭喜获得
	withdraw_rush_rule_modal: () => import('@/components/common/modal/withdraw/withdrawRushRuleModal'), // 活动页面-领取成功弹窗
	activity_task_modal: () => import('@/components/common/modal/activity/TaskSuccessful'),
	activity_multiple_task_modal: () => import('@/components/common/modal/activity/MultipleSuccess'),
	// 活动页面填写收件信息等
	activity_my_reward: () => import('@/components/common/modal/activity/MyReward'),
	// 活动页面余额转换金币
	activity_convert: () => import('@/components/common/modal/activity/Convert'),
	// 用户引导/mock数据弹窗
	activity_mock: () => import('@/components/common/modal/activity/Mork'),
	// 感谢好评弹窗
	first_withdraw_modal: () => import('@/components/common/modal/withdraw/firstWithDrawModal'),
	// 商城取消弹窗
	mall_cancel_order: () => import('@/components/common/modal/mall/cancel-modal'),
	// 商城收货地址确认弹窗
	mall_receiving_modal: () => import('@/components/common/modal/mall/goods-receiving-info'),
	'growth-rule-modal': () => import('@/components/common/modal/GrowthCenter/RuleModal'),
	'growth-center-rule-modal': () => import('@/components/common/modal/GrowthCenter/GrowthRuleModal'),
	'growth-center-ticket-modal': () => import('@/components/common/modal/GrowthCenter/TicketModal'),
	'growth-center-pendant-modal': () => import('@/components/common/modal/GrowthCenter/PendantModal'),
	// 感谢好评弹窗
	bind_alipay_modal: () => import('@/components/common/modal/withdraw/BindAlipayModal'),
	new_user_confirm_withdraw_modal: () => import('@/components/common/modal/withdraw/NewUserConfirmWithdrawModal'),
	withdraw_notice_modal: () => import('@/components/common/modal/fission/WithdrawNoticeModal'),
	blind_box_toast_modal: () => import('@/components/common/modal/withdraw/BlindBoxToastModal.vue'),
};



// WEBPACK FOOTER //
// ./src/components/common/modal/modal-routes.js